import { render, staticRenderFns } from "./TabEditor.vue?vue&type=template&id=b99cd020&scoped=true&"
import script from "./TabEditor.vue?vue&type=script&lang=ts&"
export * from "./TabEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99cd020",
  null
  
)

export default component.exports